import { InputProps, Input, Form } from "antd";
import { CheckOutlined } from '@ant-design/icons';
import { PasswordProps } from "antd/es/input";


export const MyInputPassword = (props: PasswordProps) => {


    const { status, errors } = Form.Item.useStatus();


    return (

        <Input.Password
            {...props}
            suffix={(status === 'success' && props.value) ? <CheckOutlined
                style={{ color: '#94C185', }}
            /> : <div />}

            style={{
                height: 50,
                borderRadius: 5,
                color: 'rgba(0,0,0,0.5)',
                ...props.style || {},
            }}
            styles={
                {
                    root: {
                        borderColor: (status === 'success' && props.value) ? '#94C185' : undefined,
                    },
                }
            }
        />
    )
}